import { EPromoType, IPromoInfo } from '../../../types/newbuilding/promoInfo';

export const getAuthorName = (promo: IPromoInfo): string | null | undefined => {
  const isCianMortgage = promo.promoType === EPromoType.CianMortgage;

  return isCianMortgage ? 'Циан.Ипотека' : promo.authorName;
};
